import { render, staticRenderFns } from "./InfoHeader.vue?vue&type=template&id=63b5bff8&scoped=true&lang=pug"
import script from "./InfoHeader.vue?vue&type=script&lang=js"
export * from "./InfoHeader.vue?vue&type=script&lang=js"
import style0 from "./InfoHeader.vue?vue&type=style&index=0&id=63b5bff8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b5bff8",
  null
  
)

export default component.exports